import { ErrorBoundary } from 'react-error-boundary';
import { Routes, Route } from 'react-router-dom';

import ErrorLogger from '../../../providers/ErrorLogger';
import RouteGuard from '../../../routes/RouteGuard';
import { CampaignRouter, AutomatedEmailCampaignLayout } from '../components';

export const AutomatedEmailCampaignRoutes = () => (
  <Routes>
    <Route
      path="/add-new-campaign"
      element={
        <RouteGuard>
          <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
            <CampaignRouter />
          </ErrorBoundary>
        </RouteGuard>
      }
    />
    <Route
      path="/*"
      element={
        <RouteGuard>
          <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
            <AutomatedEmailCampaignLayout />
          </ErrorBoundary>
        </RouteGuard>
      }
    />
  </Routes>
);
